// @flow

export const RESET_STORE_AFTER_LOGOUT_TYPE = 'rootReducer/RESET_AFTER_LOGOUT'

export const resetAfterLogout = () => ({
  type: RESET_STORE_AFTER_LOGOUT_TYPE,
})
